<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/39VUAn/tc-custom/9781507188644.jpg?1692614730474" alt="This image is the cover for the book Um Rapaz para o Monstro de Tentáculos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Um Rapaz para o Monstro de Tentáculos
      </h1>
      <p class="bookDescription body article font2">
        <p>Era o décimo oitavo aniversário de Ian, e tudo o que ele queria era ir com o pai para a cidade do castelo de Gabbs. Infelizmente, o sacrifício anual ao jinn, um horrível monstro de tentáculos, aconteceria naquela noite, adiando sua busca para buscar uma assembleia com o rei. Forçado a ficar em uma pousada até que o ritual acabasse, Ian deixou seu pai para explorar a cidade. Pouco ele sabia que o jinn estaria muito mais interessado nele do que os sacrifícios que tinham sido apresentados.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kyler Matthew, José Roberto Rosado Corrêa Filho
      </h2>
      
      <p class="authorDescription body article">Kyler Matthew escreve romances sensuais eróticos gays e romances eróticos em uma variedade de subgêneros com foco em paranormal e ficção científica.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a2f2d36